import * as React from "react";
import Wrapper from "../../../components/Wrapper";
import {
  Button,
  FormControl,
  Input,
  InputAdornment,
  Container,
  CircularProgress,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import SendIcon from "@mui/icons-material/Send";
import title from "../../../components/title";
import "./newRequest.css";
import { SendMail } from "../../../redux/reducer/SendEmail";
import { ToastContainer, toast } from "react-toastify";
import { GetLandlordEmails } from "../../../redux/reducer/GetLandlordEmails";


import { addNewSchema } from "./validationSchema";
import { useFormik } from "formik";

export default function AddNew() {
  title("Add New Tenant");
  const dispatch = useDispatch();

  const open = useSelector((state) => state.sidebar.open);
  const [, setRows] = React.useState([]);

  const [loader] = React.useState(false);
  
  const loaderSate = useSelector((state) => state?.SendEmail?.loading);
  const { validateUser } = useSelector((state) => state);
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: addNewSchema,
    onSubmit: (values, action) => {
      dispatch(
        SendMail({
          email: values?.email,
          userId: localStorage.getItem("user_id"),
          userName: localStorage.getItem("name"),
        })
      ).then((res) => {
        dispatch(GetLandlordEmails({})).then((resp) => {
          setRows(resp?.payload?.data?.data);
        });

        if (res?.payload?.data?.success) {
          toast.success(res?.payload?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        } else {

          toast.error(res?.payload?.data?.message || "Something went wrong", {
            position: "top-center",
          });
        }
      });
      action.resetForm();
    },
  });

  React.useEffect(() => {
    // axios({
    //   method: "POST",
    //   url: `${BASE_URL}/validateUser`,
    //   headers: {
    //     Accept: "application/json",
    //     Authorization: "Bearer " + token,
    //   },
    // }).then((res) => {
    //   setIsBank(res?.data?.user?.is_bank);
    //   setLoader(false);
    // });
    if (validateUser?.UserValidate?.data?.user?.is_bank) {
      dispatch(GetLandlordEmails({})).then((res) => {
        setRows(res?.payload?.data?.data);
        
      });
    }
  }, [dispatch, validateUser]);

  return (
    <>
      {loaderSate && (
        <div className="loader-overlay">
          <CircularProgress />
        </div>
      )}
      <Wrapper open={open} />
      <div className={`${open ? "sidebar-open" : "sidebar-closed"} `}>
        <div
          className="mainHeading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h1>Add New Tenant</h1>
        </div>

        {loader ? (
          <div className="flex">
            <CircularProgress size={42} color="inherit" />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Container maxWidth="sm" className="add-new-container">
              <FormControl className="w100 mb-10">
                <Input
                  id="input-with-icon-adornment"
                  placeholder="Enter Email Address"
                  startAdornment={
                    <InputAdornment position="start">
                      <MarkunreadIcon />
                    </InputAdornment>
                  }
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="error-style">{formik.errors.email}</p>
                )}
              </FormControl>
              <Button
                className="addNewButton"
                variant="contained"
                type="submit"
                endIcon={<SendIcon />}
                disabled={!formik.values.email || !formik.isValid}
              >
                Send
              </Button>
            </Container>
          </form>
        )}

        <ToastContainer />

        {/* {tableLoader ? (
          <div className="flex">
            <CircularProgress size={42} color="inherit" />
          </div>
        ) : (
          rows?.length > 0 && (
            <div>
              <h2>Sent Emails</h2>
              <DefaultTable />
            </div>
          )
        )} */}
      </div>
    </>
  );
}
